webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(172),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return disqusUrl; });
function disqusUrl() {
  var origin = window.location.origin;
  var pathname = window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/';
  return origin + pathname;
}



/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Splash__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Splash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Splash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Posts__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Posts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Posts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Post__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Tags__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Tags__);







if (!window.root || window.root === '') {
  window.root = '/';
} else if (!window.root.endsWith('/')) {
  window.root += '/';
}

var root = window.root;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: root,
  name: 'Splash',
  component: __WEBPACK_IMPORTED_MODULE_2__views_Splash___default.a
}, {
  path: root + 'posts',
  name: 'Posts',
  component: __WEBPACK_IMPORTED_MODULE_3__views_Posts___default.a
}, {
  path: root + 'post/:slug',
  props: function props(route) {
    return route.params;
  },
  name: 'Post',
  component: __WEBPACK_IMPORTED_MODULE_4__views_Post___default.a
}, {
  path: root + 'tags',
  name: 'Tags',
  props: function props() {
    return null;
  },
  component: __WEBPACK_IMPORTED_MODULE_5__views_Tags___default.a
}, {
  path: root + 'tags/:tag',
  name: 'Tag',
  component: __WEBPACK_IMPORTED_MODULE_5__views_Tags___default.a,
  props: function props(route) {
    return route.params;
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
}));

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_join__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(84);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var state = {
  themeCfg: null,
  siteCfg: null,
  article: {},
  page: {},
  pages: [],
  post: null,
  posts: [],
  tags: null,
  status: 200 };

var getters = {
  posts: function posts(state) {
    return state.posts;
  },
  post: function post(state) {
    return state.post;
  },
  article: function article(state) {
    return state.article;
  },
  pages: function pages(state) {
    return state.pages;
  },
  page: function page(state) {
    return state.page;
  },
  tags: function tags(state) {
    return state.tags;
  },
  themeCfg: function themeCfg(state) {
    return state.themeCfg;
  },
  siteCfg: function siteCfg(state) {
    return state.siteCfg;
  },
  status: function status(state) {
    return state.status;
  }
};

var mutations = {
  updatePosts: function updatePosts(state, _ref) {
    var posts = _ref.posts;

    state.posts = posts;
  },
  updatePost: function updatePost(state, _ref2) {
    var post = _ref2.post;

    state.post = post;
  },
  updateArticle: function updateArticle(state, _ref3) {
    var article = _ref3.article;

    state.article = article;
  },
  updatePages: function updatePages(state, _ref4) {
    var pages = _ref4.pages;

    state.pages = pages;
  },
  updatePage: function updatePage(state, _ref5) {
    var page = _ref5.page;

    state.page = page;
  },
  updateTags: function updateTags(state, _ref6) {
    var tags = _ref6.tags;

    state.tags = tags;
  },
  updateThemeCfg: function updateThemeCfg(state, themeCfg) {
    state.themeCfg = themeCfg;
  },
  updateSiteCfg: function updateSiteCfg(state, siteCfg) {
    state.siteCfg = siteCfg;
  },
  updateStatus: function updateStatus(state, status) {
    state.status = status;
  }
};

var actions = {
  fetchSiteCfg: function fetchSiteCfg(_ref7) {
    var commit = _ref7.commit;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/site.json').then(function (_ref8) {
      var data = _ref8.data;

      commit('updateSiteCfg', data);
    });
  },
  fetchThemeCfg: function fetchThemeCfg(_ref9) {
    var commit = _ref9.commit;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/theme.json').then(function (_ref10) {
      var data = _ref10.data;

      data.Drawer.filter(function (item) {
        return item.type === 'sitelink' || item.type === 'page';
      }).forEach(function (item) {
        item.link = __WEBPACK_IMPORTED_MODULE_3_url_join___default()(window.root, item.link);
      });
      data.Splash.filter(function (item) {
        return item.type === 'sitelink' || item.type === 'page';
      }).forEach(function (item) {
        item.link = __WEBPACK_IMPORTED_MODULE_3_url_join___default()(window.root, item.link);
      });
      commit('updateThemeCfg', data);
    });
  },
  fetchPosts: function fetchPosts(_ref11) {
    var commit = _ref11.commit;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/posts.json').then(function (_ref12) {
      var data = _ref12.data;

      commit('updatePosts', {
        posts: data.sort(function (x, y) {
          return new Date(y.date).getTime() - new Date(x.date).getTime();
        })
      });
    });
  },
  fetchPost: function fetchPost(_ref13, _ref14) {
    var commit = _ref13.commit;
    var slug = _ref14.slug;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/articles/' + slug + '.json').then(function (_ref15) {
      var data = _ref15.data;

      commit('updatePost', {
        post: data
      });
    });
  },
  fetchPage: function fetchPage(_ref16, _ref17) {
    var commit = _ref16.commit;
    var layout = _ref17.layout;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/page/' + layout + '.json').then(function (_ref18) {
      var data = _ref18.data;

      commit('updatePage', {
        page: data
      });
    });
  },
  fetchPages: function fetchPages(_ref19) {
    var commit = _ref19.commit;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/pages.json').then(function (_ref20) {
      var data = _ref20.data;

      data = data.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          link: __WEBPACK_IMPORTED_MODULE_3_url_join___default()(window.root, item.link)
        });
      });
      commit('updatePages', {
        pages: data
      });
    });
  },
  fetchTags: function fetchTags(_ref21) {
    var commit = _ref21.commit;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/tags.json').then(function (_ref22) {
      var data = _ref22.data;

      commit('updateTags', {
        tags: data
      });
    });
  },
  fetchPostsByTag: function fetchPostsByTag(_ref23, _ref24) {
    var commit = _ref23.commit;
    var tag = _ref24.tag;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get('api/tags/' + tag + '.json').then(function (_ref25) {
      var data = _ref25.data;

      commit('updatePosts', {
        posts: data.postlist.sort(function (x, y) {
          return new Date(y.date).getTime() - new Date(x.date).getTime();
        })
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  actions: actions,
  mutations: mutations,
  state: state,
  getters: getters
}));

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: window.root
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fecha__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fecha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fecha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Page__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fastclick__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fastclick__);














__WEBPACK_IMPORTED_MODULE_10_fastclick___default.a.attach(window.document.body);

__WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.configure({ speed: 400 });

__WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.request.use(function (config) {
  __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.start();
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_9_nprogress___default.a.done();
  return response;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('timePretty', function (date) {
  return __WEBPACK_IMPORTED_MODULE_5_fecha___default.a.format(new Date(date), 'YYYY - MM - DD');
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('fetchSiteCfg'), __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('fetchThemeCfg'), __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('fetchPages')]).then(function () {
  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].addRoutes(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.pages.map(function (item) {
    return {
      path: item.link,
      component: __WEBPACK_IMPORTED_MODULE_6__views_Page___default.a,
      props: { layout: item.layout }
    };
  }));

  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].addRoutes([{
    name: 'NotFound',
    path: window.root + '*',
    component: __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default.a
  }]);

  new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
  });
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_NotFound__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'only-nav': __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue___default.a,
    'only-not-found': __WEBPACK_IMPORTED_MODULE_2__views_NotFound___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['status']))
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_medium_zoom__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Disqus__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Disqus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Disqus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Livere__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Livere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Livere__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'only-disqus': __WEBPACK_IMPORTED_MODULE_3__components_Disqus___default.a,
    'only-livere': __WEBPACK_IMPORTED_MODULE_4__components_Livere___default.a
  },
  props: ['article', 'config'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['themeCfg'])),
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_medium_zoom__["a" /* default */])('article.content img', {
      background: 'rgba(255, 255, 255, 0.7)'
    });
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    config: {
      required: true,
      type: Object
    }
  },
  mounted: function mounted() {
    this.loadDisqus();
  },

  methods: {
    addDisqusScript: function addDisqusScript() {
      if (typeof DISQUS !== 'undefined') {
        return;
      }

      var disqusEmbed = document.getElementById('disqus_embed');
      if (disqusEmbed) {
        disqusEmbed.parent.remove(disqusEmbed);
      }

      var child = this.disqus = document.createElement('script');
      var parent = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];

      child.async = true;
      child.type = 'text/javascript';
      child.src = 'https://' + this.config.shortname + '.disqus.com/embed.js';
      child.id = 'disqus_embed';
      parent.appendChild(child);
    },
    loadDisqus: function loadDisqus() {
      var props = this.config;

      if (typeof window.DISQUS !== 'undefined') {
        window.DISQUS.reset({
          reload: true,
          config: function config() {
            this.page.title = props.title;
            this.page.url = props.url;
            this.page.identifier = props.identifier;
          }
        });
      } else {
        window.disqus_config = function config() {
          this.page.title = props.title;
          this.page.url = props.url;
          this.page.identifier = props.identifier;
        };
        this.addDisqusScript();
      }
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item']
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    config: {
      required: true,
      type: Object
    }
  },
  mounted: function mounted() {
    (function (d, s) {
      var j = void 0;
      var e = d.getElementsByTagName(s)[0];

      if (typeof LivereTower === 'function') {
        return;
      }

      j = d.createElement(s);
      j.src = 'https://cdn-city.livere.com/js/embed.dist.js';
      j.async = true;

      e.parentNode.insertBefore(j, e);
    })(document, 'script');
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    loading: {
      default: false
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkItem__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LinkItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'only-link': __WEBPACK_IMPORTED_MODULE_2__components_LinkItem___default.a
  },
  data: function data() {
    return {
      active: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['themeCfg'])),
  methods: {
    toggleBar: function toggleBar() {
      this.active = !this.active;
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['post'],
  methods: {
    fetchTag: function fetchTag(tag) {
      var _this = this;

      this.$router.push({
        name: 'Tag',
        params: {
          tag: tag
        }
      });
      this.$store.dispatch('fetchPostsByTag', {
        tag: tag
      }).then(function () {
        document.title = tag + ' | ' + _this.siteCfg.title;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['siteCfg']))
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Container__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Page__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    if (this.$route.query.redirect) {
      this.$router.replace(this.$route.query.redirect);
    }
  },

  components: {
    'only-container': __WEBPACK_IMPORTED_MODULE_1__components_Container___default.a,
    'only-page': __WEBPACK_IMPORTED_MODULE_2__views_Page___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['themeCfg'])),
  watch: {
    '$route.path': function $routePath(to, from) {
      this.$store.commit('updateStatus', 200);
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ArticleItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(14);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['layout'],
  data: function data() {
    return {
      loading: true,
      notExisted: false
    };
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.refresh(this.layout).then(function () {
      _this.loading = false;
    });
  },

  components: {
    'only-article': __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem___default.a,
    'only-container': __WEBPACK_IMPORTED_MODULE_3__components_Container___default.a,
    'only-loading': __WEBPACK_IMPORTED_MODULE_4__components_Loading___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['page', 'themeCfg', 'siteCfg']), {
    config: function config() {
      return this.themeCfg.disqus_shortname ? {
        shortname: this.themeCfg.disqus_shortname,
        url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])(),
        title: document.title,
        identifier: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])()
      } : { livere_uid: this.themeCfg.livere_uid };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchPage']), {
    refresh: function refresh(layout) {
      var _this2 = this;

      this.notExisted = false;
      return this.fetchPage({ layout: layout }).then(function () {
        document.title = _this2.page.title + ' | ' + _this2.siteCfg.title;
      }).catch(function (err) {
        if (err.response && err.response.status === 404) {
          _this2.notExisted = true;
        }
      });
    }
  }),
  watch: {
    'layout': function layout(to, from) {
      var _this3 = this;

      this.loading = true;
      this.refresh(to).then(function () {
        _this3.loading = false;
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].nextTick(function () {
          window.DISQUS.reset({
            reload: true,
            config: function config() {
              this.page.identifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])();
              this.page.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])();
              this.page.title = document.title;
              console.log(this.page.identifier, this.page.url);
            }
          });
        });
      });
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ArticleItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(39);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['slug'],
  created: function created() {
    var _this = this;

    this.fetchPost({ slug: this.slug }).then(function () {
      document.title = _this.post.title + ' | ' + _this.siteCfg.title;
      _this.loading = false;
    }).catch(function (err) {
      if (err.response && err.response.status === 404) {
        _this.notExisted = true;
        _this.$store.commit('updateStatus', 404);
      }
      _this.loading = false;
    });
  },

  components: {
    'only-article': __WEBPACK_IMPORTED_MODULE_2__components_ArticleItem___default.a,
    'only-container': __WEBPACK_IMPORTED_MODULE_3__components_Container___default.a,
    'only-loading': __WEBPACK_IMPORTED_MODULE_4__components_Loading___default.a
  },
  data: function data() {
    return {
      loading: true,
      notExisted: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['post', 'themeCfg', 'siteCfg']), {
    config: function config() {
      return this.themeCfg.disqus_shortname ? {
        shortname: this.themeCfg.disqus_shortname,
        url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])(),
        title: document.title,
        identifier: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* disqusUrl */])()
      } : { livere_uid: this.themeCfg.livere_uid };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchPost']))
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PostItem__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PostItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PostItem__);







/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    this.fetchPosts().then(function () {
      document.title = 'Posts | ' + _this.siteCfg.title;
    });
  },

  components: {
    'only-container': __WEBPACK_IMPORTED_MODULE_2__components_Container___default.a,
    'only-post': __WEBPACK_IMPORTED_MODULE_3__components_PostItem___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['posts', 'siteCfg', 'themeCfg'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['fetchPosts']))
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkItem__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LinkItem__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'only-link': __WEBPACK_IMPORTED_MODULE_2__components_LinkItem___default.a
  },
  created: function created() {
    document.title = 'Home | ' + this.siteCfg.title;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['themeCfg', 'siteCfg']), {
    style: function style() {
      if (true) {
        return {
          'backgroundImage': 'url(' + window.root + 'img/background.jpg)'
        };
      }
    }
  })
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PostItem__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PostItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PostItem__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tag'],
  data: function data() {
    return {
      noTags: false,
      notExisted: false
    };
  },

  components: {
    'only-container': __WEBPACK_IMPORTED_MODULE_3__components_Container___default.a,
    'only-post': __WEBPACK_IMPORTED_MODULE_4__components_PostItem___default.a
  },
  created: function created() {
    var _this = this;

    var p = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    if (this.tags == null) {
      p = this.fetchTags().then(function () {
        if (_this.tag == null) {
          _this.$router.push({
            name: 'Tag',
            params: {
              tag: _this.tags[0].name
            }
          });
        }
      }).catch(function (err) {
        if (err.response && err.response.status === 404) {
          _this.noTags = true;
          _this.$store.commit('updateStatus', 404);
        }
      });
    }
    p.then(function () {
      if (!_this.noTags && _this.tag != null) {
        return _this.fetchPostsByTag({ tag: _this.tag });
      }
    }).catch(function (err) {
      if (err.response && err.response.status === 404) {
        _this.notExisted = true;
        _this.$store.commit('updateStatus', 404);
      }
    }).then(function () {
      document.title = _this.tag + ' | ' + _this.siteCfg.title;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['tags', 'posts', 'siteCfg', 'themeCfg'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['fetchTags', 'fetchPostsByTag']), {
    fetchTag: function fetchTag(tag) {
      this.$router.push({
        name: 'Tag',
        params: {
          tag: tag
        }
      });
      this.fetchPostsByTag({ tag: tag });
      document.title = tag + ' | ' + this.siteCfg.title;
    }
  })
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.type === 'permalink') ? _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": _vm.item._blank ? '_blank' : ''
    }
  }, [_vm._v(_vm._s(_vm.item.title))]) : _c('router-link', {
    attrs: {
      "to": _vm.item.link
    }
  }, [_vm._v(_vm._s(_vm.item.title))])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lv-container",
      "data-id": "city",
      "data-uid": _vm.config.livere_uid
    }
  })
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', [(_vm.notExisted) ? _c('div', [_c('h2', [_vm._v("嗯，这个标签并不存在")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://as.bitinn.net/upload/cj2l8o36f00ofbo5nj7spml66.1200.jpg"
    }
  })]) : _c('div', [(_vm.tags) ? _c('div', {
    staticClass: "tags-container"
  }, _vm._l((_vm.tags), function(item) {
    return _c('span', {
      staticClass: "tag",
      class: {
        'active': _vm.tag === item.name
      },
      on: {
        "click": function($event) {
          _vm.fetchTag(item.name)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])
  })) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('only-post', {
      key: post.title,
      staticClass: "animated",
      class: _vm.themeCfg.animated && _vm.themeCfg.animated.tags,
      attrs: {
        "post": post
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Loading")]), _vm._v(" "), _c('div', {
    staticClass: "pacman"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.name !== 'Splash') ? _c('only-nav') : _vm._e(), _vm._v(" "), (_vm.status !== 404) ? _c('router-view') : _c('only-not-found')], 1)
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', _vm._l((_vm.posts), function(post) {
    return _c('only-post', {
      key: post.title,
      staticClass: "animated",
      class: _vm.themeCfg.animated && _vm.themeCfg.animated.posts,
      attrs: {
        "post": post
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "splash"
  }, [_c('section', {
    staticClass: "body",
    style: (_vm.style)
  }, [_c('section', {
    staticClass: "shadow"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.siteCfg.title))]), _vm._v(" "), _c('nav', _vm._l((_vm.themeCfg.Splash), function(item) {
    return _c('only-link', {
      key: item.title,
      attrs: {
        "item": item
      }
    })
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.themeCfg.page404 == null) ? _c('only-container', [_c('h1', [_vm._v("404 Not Found")]), _vm._v(" "), _c('h3', [_vm._v(" 迷路了么？这里什么也不存在 ")]), _vm._v(" "), _c('p', [_vm._v(" 回到 "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Splash'
      }
    }
  }, [_vm._v("最开始的地方吧")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://as.bitinn.net/upload/cite0l5z200oiz35nbv8t5xox.1200.jpg",
      "alt": ""
    }
  })]) : _c('only-page', {
    attrs: {
      "layout": "page404"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog-item"
  }, [_c('router-link', {
    staticClass: "title",
    attrs: {
      "tag": "h2",
      "to": {
        name: 'Post',
        params: {
          slug: _vm.post.slug
        }
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.post.title) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timePretty")(_vm.post.date)))]), _vm._v(" "), _vm._l((_vm.post.tags), function(tag) {
    return _c('span', {
      staticClass: "tag",
      on: {
        "click": function($event) {
          _vm.fetchTag(tag.name)
        }
      }
    }, [_vm._v("#" + _vm._s(tag.name))])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-container",
    on: {
      "click": _vm.toggleBar
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated slideInLeft fadeIn",
      "leave-active-class": "animated slideOutLeft fadeOut"
    }
  }, [(_vm.active) ? _c('div', {
    staticClass: "nav"
  }, [_vm._l((_vm.themeCfg.Drawer), function(item) {
    return _c('only-link', {
      key: item.title,
      staticClass: "item",
      attrs: {
        "item": item
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "icon ion-chevron-left"
  })])], 2) : _c('div', {
    key: "entry",
    staticClass: "entry",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleBar($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-chevron-right"
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('only-container', [_c('only-loading', {
    attrs: {
      "loading": _vm.loading
    }
  }, [(!_vm.notExisted) ? _c('only-article', {
    staticClass: "animated",
    class: _vm.themeCfg.animated && _vm.themeCfg.animated.page,
    attrs: {
      "article": _vm.page,
      "config": _vm.config
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', [_c('only-loading', {
    attrs: {
      "loading": _vm.loading
    }
  }, [(!_vm.notExisted && _vm.post) ? _c('only-article', {
    staticClass: "animated",
    class: _vm.themeCfg.animated && _vm.themeCfg.animated.post,
    attrs: {
      "article": _vm.post,
      "config": _vm.config
    }
  }) : _c('h1', [_vm._v("This Post is Not Existed")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('hr', {
    staticClass: "splitline"
  }), _vm._v(" "), _c('article', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(" " + _vm._s(_vm._f("timePretty")(_vm.article.date)) + "\n    / Updated on " + _vm._s(_vm._f("timePretty")(_vm.article.updated)) + "\n   ")]), _vm._v(" "), _c('hr', {
    staticClass: "splitline"
  }), _vm._v(" "), (_vm.article.comments && _vm.config && _vm.themeCfg.disqus_shortname) ? _c('only-disqus', {
    attrs: {
      "config": _vm.config
    }
  }) : (_vm.article.comments && _vm.config && _vm.themeCfg.livere_uid) ? _c('only-livere', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
],[85]);


// WEBPACK FOOTER //
// js/app.js